import ValidationRule from './ValidationRule';

class MinLengthValidationRule extends ValidationRule {
  constructor(message, minLength) {
    message = (message || '').replace('$minLength', minLength);
    super(message);

    this._minLength = minLength;
  }

  validate(val) {
    return (val || '').length >= this._minLength;
  }
}

export default MinLengthValidationRule;



// WEBPACK FOOTER //
// ./src/common/core/validation/validationRules/MinLengthValidationRule.js